import { NgClass } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ActionButtonComponent } from "../action-button/action-button.component";
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from "../header/header.component";

@Component({
    selector: "rask-page",
    styleUrls: ["./page.component.scss"],
    templateUrl: "./page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ActionButtonComponent,
        NgClass,
        FooterComponent
    ]
})
export class PageComponent implements AfterViewInit {
    @Input() actionDisabled = false;
    @Input() actionFn = null;
    @Input() actionShow = false;
    @Input() actionTitle: string;
    @Input() contentClass: string;
    @Input() contentShow = true;
    @Input() footerShow = true;
    @ViewChild("headerContent", { static: false }) headerContent: ElementRef;
    headerContentShow = true;
    @Input() headerShow = true;
    @Input() noPadding = "";
    @Input() pageTitle: string;

    private readonly cdRef = inject(ChangeDetectorRef);

    action() {
        if (this.actionFn && !this.actionDisabled) {
            this.actionFn();
        }
    }

    isEmpty(element: ElementRef) {
        return !element || !element.nativeElement || element.nativeElement.childNodes.length === 0;
    }

    ngAfterViewInit(): void {
        this.headerContentShow = !this.isEmpty(this.headerContent);
        this.cdRef.detectChanges();
    }
}
